import { StyledTableCell } from 'components/Table';
import * as S from 'pages/invoices/components/InvoiceDetails/details.styled';
import { InvoiceTaxTotals } from 'pages/invoices/invoices.types';
import { useTranslation } from 'react-i18next';
import { numberWithCommas } from 'utils/numberFunctions.utils';

type Props = {
  taxTotals: InvoiceTaxTotals[];
};

export const InvoiceLinesSummary = ({ taxTotals }: Props) => {
  const { t } = useTranslation(['invoice']);

  return (
    <>
      {taxTotals.map((taxTotal, idx) => (
        <S.TableRow selected key={taxTotal.id}>
          <StyledTableCell colSpan={idx ? 7 : 6} height='condensed' />
          {!idx && (
            <StyledTableCell align='right' height='condensed'>
              {t('including', { ns: 'invoice' })}
            </StyledTableCell>
          )}
          <StyledTableCell height='condensed' align='right'>
            {numberWithCommas(taxTotal.amounts.netValue)}
          </StyledTableCell>
          <StyledTableCell height='condensed' align='right'>
            {taxTotal.amounts.taxRate.code}
          </StyledTableCell>
          <StyledTableCell height='condensed' align='right'>
            {numberWithCommas(taxTotal.amounts.taxValue)}
          </StyledTableCell>
          <StyledTableCell height='condensed' align='right'>
            {numberWithCommas(taxTotal.amounts.grossValue)}
          </StyledTableCell>
          <StyledTableCell height='condensed' />
        </S.TableRow>
      ))}
    </>
  );
};
